<script setup>
// ContactsList.vue — wrapper fino que renderiza a tabela densa
// (ContactsTable) + dialog de exclusao individual.
//
// Selecao bulk e mantida em ContactsIndex (passada via prop/emit),
// porque ela tambem alimenta a ContactsBulkActionsBar do layout.
// Acoes inline da linha:
//   view  -> navega pro detalhe (mesma rota do botao "Ver detalhes"
//            antigo, com fallback de segmentId/label)
//   edit  -> navega pro detalhe (UI de edicao vive la dentro)
//   delete -> abre dialog de confirmacao
import { ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';

import ContactsTable from 'dashboard/components-next/Contacts/Pages/ContactsTable.vue';
import ConfirmContactDeleteDialog from 'dashboard/components-next/Contacts/ContactsForm/ConfirmContactDeleteDialog.vue';

defineProps({
  contacts: { type: Array, required: true },
  selected: { type: Set, default: () => new Set() },
});

const emit = defineEmits(['update:selected']);

const router = useRouter();
const route = useRoute();

const confirmDeleteDialogRef = ref(null);
const contactToDelete = ref(null);

const navigateToContact = id => {
  const routeTypes = {
    contacts_dashboard_segments_index: ['contacts_edit_segment', 'segmentId'],
    contacts_dashboard_labels_index: ['contacts_edit_label', 'label'],
  };
  const [name, paramKey] = routeTypes[route.name] || ['contacts_edit'];
  const params = {
    contactId: id,
    ...(paramKey && { [paramKey]: route.params[paramKey] }),
  };
  router.push({ name, params, query: route.query });
};

const handleView = id => navigateToContact(id);
const handleEdit = id => navigateToContact(id);

const handleDelete = contact => {
  contactToDelete.value = contact;
  confirmDeleteDialogRef.value?.dialogRef.open();
};
</script>

<template>
  <ContactsTable
    :contacts="contacts"
    :selected="selected"
    @update:selected="emit('update:selected', $event)"
    @view="handleView"
    @edit="handleEdit"
    @delete="handleDelete"
  />
  <ConfirmContactDeleteDialog
    v-if="contactToDelete"
    ref="confirmDeleteDialogRef"
    :selected-contact="contactToDelete"
  />
</template>
